import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: calc(100% - 4rem);
  width: 100%;
  margin-bottom: 4rem;
  align-items: flex-end;
  justify-content: center;
`;
